// extracted by mini-css-extract-plugin
export default {"card":"Catalogo_card__ia6kQ"};